import { Component } from '@angular/core';
import { ADBInfo, DBPanelInfo, LexbizzDBInfo } from '../../../../../models/datamodel/adbinfo.model';
import { BaseDataSourcePanel } from '../../../../../settings/datamodel/datasource/datasourcepanels/basedatasource.panel';

@Component({
    selector: 'lexbizz-panel',
    templateUrl: './lexbizz.panel.html'
})
export class LexbizzPanel extends BaseDataSourcePanel {

    static GetInfo(): DBPanelInfo {
        return {
            ControlType: LexbizzPanel,
            DBInfoType: LexbizzDBInfo
        };
    }

    constructor() {
        super();
        this.DBInfoType = LexbizzDBInfo;
    }   
}
